var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "tabBar" },
        _vm._l(_vm.tabBars, function (i, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "tabItem",
              class: { itemActive: _vm.curIndex == index },
              on: {
                click: function ($event) {
                  return _vm.changeTab(i, index)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(i) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.curIndex == 0
        ? _c(
            "div",
            { staticClass: "addEditForm" },
            [
              _c(
                "el-form",
                {
                  ref: "form0",
                  attrs: {
                    model: _vm.form0,
                    "label-width": "170px",
                    rules: _vm.rules0,
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "marRight20" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "申报单位：",
                            prop: "declarationUnit",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { minlength: "1", maxlength: "30" },
                            model: {
                              value: _vm.form0.declarationUnit,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "declarationUnit", $$v)
                              },
                              expression: "form0.declarationUnit",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "课程名称：" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form0.courseName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "courseName", $$v)
                              },
                              expression: "form0.courseName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "课程层次：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form0.curriculumLevel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form0, "curriculumLevel", $$v)
                                },
                                expression: "form0.curriculumLevel",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "高职课程" } }, [
                                _vm._v("高职课程"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                { attrs: { label: "职教本科课程" } },
                                [_vm._v("职教本科课程")]
                              ),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "中职课程" } }, [
                                _vm._v("中职课程"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "课程类型：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form0.courseType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form0, "courseType", $$v)
                                },
                                expression: "form0.courseType",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { label: "公共基础课" } },
                                [_vm._v("公共基础课")]
                              ),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "专业课" } }, [
                                _vm._v("专业课"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "立项类别：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form0.projectCategory,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form0, "projectCategory", $$v)
                                },
                                expression: "form0.projectCategory",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "A类" } }, [
                                _vm._v("A类"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "B类" } }, [
                                _vm._v("B类"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属专业大类：", prop: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              on: { change: _vm.chooseMajor },
                              model: {
                                value: _vm.form0.majorCatId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form0, "majorCatId", $$v)
                                },
                                expression: "form0.majorCatId",
                              },
                            },
                            _vm._l(_vm.majorList, function (i) {
                              return _c("el-option", {
                                key: i.id,
                                attrs: { label: i.majorName, value: i.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属专业二级类：", prop: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              on: { change: _vm.chooseMajorTwo },
                              model: {
                                value: _vm.form0.majorGroupId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form0, "majorGroupId", $$v)
                                },
                                expression: "form0.majorGroupId",
                              },
                            },
                            _vm._l(_vm.majorListTwo, function (i) {
                              return _c("el-option", {
                                key: i.id,
                                attrs: { label: i.majorName, value: i.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "专业类代码：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              minlength: "1",
                              maxlength: "10",
                              oninput:
                                "this.value=this.value.replace(/[^0-9-]+/,'');",
                            },
                            model: {
                              value: _vm.form0.professionalCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "professionalCode", $$v)
                              },
                              expression: "form0.professionalCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "课程负责人：" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form0.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "name", $$v)
                              },
                              expression: "form0.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "申报日期：" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              placeholder: "选择申报日期",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.form0.declarationDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form0, "declarationDate", $$v)
                              },
                              expression: "form0.declarationDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submitBtn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.submit("form0")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curIndex == 1
        ? _c(
            "div",
            { staticClass: "addEditForm" },
            [
              _c(
                "el-form",
                {
                  ref: "form1",
                  attrs: {
                    model: _vm.form1,
                    "label-width": "170px",
                    rules: _vm.rules1,
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "marRight20" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名：", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入姓名",
                              minlength: "1",
                              maxlength: "30",
                            },
                            model: {
                              value: _vm.form1.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "name", $$v)
                              },
                              expression: "form1.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别：", prop: "sex" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form1.sex,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form1, "sex", $$v)
                                },
                                expression: "form1.sex",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "男" } }, [
                                _vm._v("男"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "女" } }, [
                                _vm._v("女"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "出生年月：", prop: "birthday" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "month",
                              placeholder: "选择出生年月",
                              "value-format": "yyyy-MM",
                            },
                            model: {
                              value: _vm.form1.birthday,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "birthday", $$v)
                              },
                              expression: "form1.birthday",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "最终学历：", prop: "education" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入最终学历",
                              minlength: "1",
                              maxlength: "30",
                            },
                            model: {
                              value: _vm.form1.education,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "education", $$v)
                              },
                              expression: "form1.education",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "学位：", prop: "academicDegree" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入学位",
                              minlength: "1",
                              maxlength: "30",
                            },
                            model: {
                              value: _vm.form1.academicDegree,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "academicDegree", $$v)
                              },
                              expression: "form1.academicDegree",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "专业技术职务：",
                            prop: "technicalPosition",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入专业技术职务",
                              minlength: "1",
                              maxlength: "30",
                            },
                            model: {
                              value: _vm.form1.technicalPosition,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "technicalPosition", $$v)
                              },
                              expression: "form1.technicalPosition",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "行政职务(选填)：",
                            prop: "administrativePosition",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入行政职务",
                              minlength: "1",
                              maxlength: "30",
                            },
                            model: {
                              value: _vm.form1.administrativePosition,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form1,
                                  "administrativePosition",
                                  $$v
                                )
                              },
                              expression: "form1.administrativePosition",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "所在院系：", prop: "department" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入所在院系",
                              minlength: "1",
                              maxlength: "30",
                            },
                            model: {
                              value: _vm.form1.department,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "department", $$v)
                              },
                              expression: "form1.department",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          key: "mobile",
                          attrs: { label: "手机：", prop: "mobile" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入手机",
                              maxlength: "11",
                            },
                            model: {
                              value: _vm.form1.mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "mobile", $$v)
                              },
                              expression: "form1.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          key: "email",
                          attrs: { label: "电子邮箱：", prop: "email" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入电子邮箱" },
                            model: {
                              value: _vm.form1.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "email", $$v)
                              },
                              expression: "form1.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "通信地址（邮编）：",
                            prop: "address",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入通信地址（邮编）",
                              minlength: "1",
                              maxlength: "100",
                            },
                            model: {
                              value: _vm.form1.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "address", $$v)
                              },
                              expression: "form1.address",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "授课情况：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "1000",
                              "show-word-limit": "",
                              rows: 8,
                              type: "textarea",
                              placeholder:
                                "请输入现课程负责人近三年讲授本课程情况；近五年来讲授的主要课程（含课程名称、课程类别、周学时；届数及学生总人数）（不超过五门）。 ",
                            },
                            model: {
                              value: _vm.form1.teachingSituation,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "teachingSituation", $$v)
                              },
                              expression: "form1.teachingSituation",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "majorWarp" },
                        [
                          _vm._l(
                            _vm.form1.courseLeaderTeachingList,
                            function (i, j) {
                              return [
                                _c(
                                  "el-row",
                                  { key: j },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 20 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "courseItem",
                                            attrs: {
                                              label: "近五年讲授的主要课程：",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "课程名称",
                                                    maxlength: "30",
                                                  },
                                                  model: {
                                                    value: i.courseName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        i,
                                                        "courseName",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "i.courseName",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "课程类型",
                                                    maxlength: "30",
                                                  },
                                                  model: {
                                                    value: i.courseType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        i,
                                                        "courseType",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "i.courseType",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "周学时",
                                                    oninput:
                                                      "this.value=(this.value.match(/\\d+(.\\d{0,2})?/)||[''])[0]",
                                                  },
                                                  model: {
                                                    value: i.classHour,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        i,
                                                        "classHour",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "i.classHour",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "届数",
                                                    oninput:
                                                      "this.value=this.value.match(/^[0-9]*[1-9][0-9]*$/,'');",
                                                  },
                                                  model: {
                                                    value: i.sessionNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        i,
                                                        "sessionNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "i.sessionNumber",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 5 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "学生总人数",
                                                    oninput:
                                                      "this.value=this.value.match(/^[0-9]*[1-9][0-9]*$/,'');",
                                                  },
                                                  on: {
                                                    input: function (e) {
                                                      return (i.studentNumber =
                                                        _vm.isnumber(e))
                                                    },
                                                  },
                                                  model: {
                                                    value: i.studentNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        i,
                                                        "studentNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "i.studentNumber",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "btnsGroup",
                                        attrs: { span: 4 },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                              plain: "",
                                            },
                                            on: { click: _vm.addWorks },
                                          },
                                          [_vm._v("新增")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                              plain: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeWorks(j)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "教学研究情况：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "1000",
                              "show-word-limit": "",
                              rows: 8,
                              type: "textarea",
                              placeholder:
                                "请输入承担的实践性教学任务（含实验、实习、课程设计、毕业设计/论文，学生总人数）。",
                            },
                            model: {
                              value: _vm.form1.teachingResearch,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "teachingResearch", $$v)
                              },
                              expression: "form1.teachingResearch",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "学术研究情况：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "1000",
                              "show-word-limit": "",
                              rows: 8,
                              type: "textarea",
                              placeholder:
                                "请输入主持的教学研究课题（含课题名称、来源、年限）（不超过五项）；作为第一署名人在国内外公开发行的刊物上发表的教学研究论文（含题目、刊物名称、时间）（不超过五项）；获得的教学表彰/奖励（不超过五项）；主编的省部级及以上规划教材、获奖教材（不超过五项）：",
                            },
                            model: {
                              value: _vm.form1.academicResearch,
                              callback: function ($$v) {
                                _vm.$set(_vm.form1, "academicResearch", $$v)
                              },
                              expression: "form1.academicResearch",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submitBtn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.submit1("form1")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curIndex == 2
        ? _c(
            "div",
            { staticClass: "addEditForm" },
            [
              _c(
                "el-form",
                {
                  ref: "form2",
                  attrs: {
                    model: _vm.form2,
                    "label-width": "170px",
                    rules: _vm.rules2,
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "marRight20" },
                    [
                      _c("div", { staticClass: "team" }, [
                        _vm._v(
                          "\n          其他人员构成（含辅导教师、教学设计、技术、支持服务等）:\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "majorWarp" },
                        [
                          _vm._l(_vm.form2.teamListParams, function (i, j) {
                            return [
                              _c(
                                "el-row",
                                { key: j },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 20 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "courseItem",
                                          attrs: {
                                            label: "其他人员基本信息：",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 4 } },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: "姓名",
                                                  maxlength: "30",
                                                },
                                                model: {
                                                  value: i.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(i, "name", $$v)
                                                  },
                                                  expression: "i.name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 3 } },
                                            [
                                              _c(
                                                "el-radio-group",
                                                {
                                                  model: {
                                                    value: i.sex,
                                                    callback: function ($$v) {
                                                      _vm.$set(i, "sex", $$v)
                                                    },
                                                    expression: "i.sex",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: "男" } },
                                                    [_vm._v("男")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: "女" } },
                                                    [_vm._v("女")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 3 } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "month",
                                                  placeholder: "出生年月",
                                                  "value-format": "yyyy-MM",
                                                },
                                                model: {
                                                  value: i.birthday,
                                                  callback: function ($$v) {
                                                    _vm.$set(i, "birthday", $$v)
                                                  },
                                                  expression: "i.birthday",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 6 } },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: "专业技术职务",
                                                  maxlength: "30",
                                                },
                                                model: {
                                                  value: i.technicalPosition,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      i,
                                                      "technicalPosition",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "i.technicalPosition",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 7 } },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: "学科专业",
                                                  maxlength: "30",
                                                },
                                                model: {
                                                  value: i.major,
                                                  callback: function ($$v) {
                                                    _vm.$set(i, "major", $$v)
                                                  },
                                                  expression: "i.major",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "在本课程中承担的工作：",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder:
                                                "请输入在本课程中承担的工作",
                                              maxlength: "3000",
                                            },
                                            model: {
                                              value: i.jobContent,
                                              callback: function ($$v) {
                                                _vm.$set(i, "jobContent", $$v)
                                              },
                                              expression: "i.jobContent",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "备注(选填)：" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              maxlength: "100",
                                              "show-word-limit": "",
                                              type: "textarea",
                                              placeholder:
                                                "如联合申报请在本栏目中注明所在高校",
                                            },
                                            model: {
                                              value: i.remarks,
                                              callback: function ($$v) {
                                                _vm.$set(i, "remarks", $$v)
                                              },
                                              expression: "i.remarks",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "btnsGroup",
                                      attrs: { span: 4 },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                          },
                                          on: { click: _vm.addTeam },
                                        },
                                        [_vm._v("新增")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            plain: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeTeam(j)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "队伍整体结构：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              maxlength: "2000",
                              "show-word-limit": "",
                              placeholder:
                                "请输入教学、辅导、设计、技术等人员的配置情况。",
                            },
                            model: {
                              value: _vm.form2.teamStructure,
                              callback: function ($$v) {
                                _vm.$set(_vm.form2, "teamStructure", $$v)
                              },
                              expression: "form2.teamStructure",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submitBtn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.submit2("form2")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curIndex == 3
        ? _c(
            "div",
            { staticClass: "addEditForm" },
            [
              _c(
                "el-form",
                {
                  ref: "form3",
                  attrs: {
                    model: _vm.form3,
                    "label-width": "170px",
                    rules: _vm.rules3,
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "marRight20" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "课程名称：", prop: "courseName" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form3.courseName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "courseName", $$v)
                              },
                              expression: "form3.courseName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "预计总学时：", prop: "totalHour" } },
                        [
                          _c("el-input", {
                            attrs: {
                              oninput:
                                "this.value=(this.value.match(/\\d+(.\\d{0,2})?/)||[''])[0]",
                            },
                            model: {
                              value: _vm.form3.totalHour,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "totalHour", $$v)
                              },
                              expression: "form3.totalHour",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "预计总时长：", prop: "totalTime" } },
                        [
                          _c("el-input", {
                            attrs: {
                              oninput:
                                "this.value=(this.value.match(/\\d+(.\\d{0,2})?/)||[''])[0]",
                            },
                            model: {
                              value: _vm.form3.totalTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "totalTime", $$v)
                              },
                              expression: "form3.totalTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "majorWarp" },
                        [
                          _vm._l(
                            _vm.form3.courseEachLectureListParams,
                            function (i, j) {
                              return [
                                _c(
                                  "el-row",
                                  { key: j },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 20 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "courseItem",
                                            attrs: { label: "每讲情况：" },
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "xuhao" },
                                                  [
                                                    _vm._v(
                                                      "序号：" + _vm._s(j + 1)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 12 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "专题标题",
                                                    maxlength: "30",
                                                  },
                                                  model: {
                                                    value: i.title,
                                                    callback: function ($$v) {
                                                      _vm.$set(i, "title", $$v)
                                                    },
                                                    expression: "i.title",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "时长",
                                                    oninput:
                                                      "this.value=(this.value.match(/\\d+(.\\d{0,2})?/)||[''])[0]",
                                                  },
                                                  model: {
                                                    value: i.duration,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        i,
                                                        "duration",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "i.duration",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 5 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "主讲教师",
                                                    maxlength: "30",
                                                  },
                                                  model: {
                                                    value: i.lecturer,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        i,
                                                        "lecturer",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "i.lecturer",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "btnsGroup",
                                        attrs: { span: 4 },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                              plain: "",
                                            },
                                            on: { click: _vm.addCourseItem },
                                          },
                                          [_vm._v("新增")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                              plain: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeCourseItem(j)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "课程建设基础：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              maxlength: "2000",
                              "show-word-limit": "",
                              placeholder:
                                "请输入目前本课程的开设情况，开设时间、年限、授课对象、授课人数，以及相关视频情况和面向社会的开放情况。",
                            },
                            model: {
                              value: _vm.form3.constructionFoundation,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form3,
                                  "constructionFoundation",
                                  $$v
                                )
                              },
                              expression: "form3.constructionFoundation",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "课程内容：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              maxlength: "2000",
                              "show-word-limit": "",
                              placeholder:
                                "请输入课程完整教学内容简介、章节安排、学时分配、重点和难点、考核方式等。",
                            },
                            model: {
                              value: _vm.form3.courseContent,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "courseContent", $$v)
                              },
                              expression: "form3.courseContent",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "预期受众定位与目标：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              maxlength: "1000",
                              "show-word-limit": "",
                              placeholder: "请输入课程预期受众的定位与目标。",
                            },
                            model: {
                              value: _vm.form3.positioningTarget,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "positioningTarget", $$v)
                              },
                              expression: "form3.positioningTarget",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "相关教学资源储备：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              maxlength: "2000",
                              "show-word-limit": "",
                              placeholder: "请输入相关教学资源储备情况。",
                            },
                            model: {
                              value: _vm.form3.resourceReserve,
                              callback: function ($$v) {
                                _vm.$set(_vm.form3, "resourceReserve", $$v)
                              },
                              expression: "form3.resourceReserve",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submitBtn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.submit3("form3")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curIndex == 4
        ? _c(
            "div",
            { staticClass: "addEditForm" },
            [
              _c(
                "el-form",
                {
                  ref: "form4",
                  attrs: {
                    model: _vm.form4,
                    "label-width": "170px",
                    rules: _vm.rules4,
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "marRight20" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "自我评价：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              maxlength: "2000",
                              "show-word-limit": "",
                              placeholder:
                                "请输入本课程的主要特色介绍、影响力分析，国内外同类课程比较。",
                            },
                            model: {
                              value: _vm.form4.selfEvaluation,
                              callback: function ($$v) {
                                _vm.$set(_vm.form4, "selfEvaluation", $$v)
                              },
                              expression: "form4.selfEvaluation",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "学生评价(选填)：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              maxlength: "2000",
                              "show-word-limit": "",
                              placeholder:
                                "如果本课程已经面向学生开设，填写学生的评价意见，如未开设可不用填写。",
                            },
                            model: {
                              value: _vm.form4.studentEvaluation,
                              callback: function ($$v) {
                                _vm.$set(_vm.form4, "studentEvaluation", $$v)
                              },
                              expression: "form4.studentEvaluation",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "社会评价(选填)：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              maxlength: "2000",
                              "show-word-limit": "",
                              placeholder:
                                "如果本课程已经全部或部分向社会开放，请填写有关人员的评价，如未开放可不用填写。",
                            },
                            model: {
                              value: _vm.form4.socialEvaluation,
                              callback: function ($$v) {
                                _vm.$set(_vm.form4, "socialEvaluation", $$v)
                              },
                              expression: "form4.socialEvaluation",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submitBtn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.submit4("form4")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curIndex == 5
        ? _c(
            "div",
            { staticClass: "addEditForm" },
            [
              _c(
                "el-form",
                {
                  ref: "form5",
                  attrs: {
                    model: _vm.form5,
                    "label-width": "170px",
                    rules: _vm.rules5,
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "marRight20" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "建设措施：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              maxlength: "2000",
                              "show-word-limit": "",
                              placeholder:
                                "请输入后续建设与维护计划及措施、预期效果、经费预算等。",
                            },
                            model: {
                              value: _vm.form5.constructionMeasures,
                              callback: function ($$v) {
                                _vm.$set(_vm.form5, "constructionMeasures", $$v)
                              },
                              expression: "form5.constructionMeasures",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submitBtn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.submit5("form5")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.curIndex == 6
        ? _c(
            "div",
            { staticClass: "addEditForm" },
            [
              _c(
                "el-form",
                {
                  ref: "form6",
                  attrs: {
                    model: _vm.form6,
                    "label-width": "170px",
                    rules: _vm.rules6,
                  },
                },
                [
                  _c("el-row", { staticClass: "marRight20" }, [
                    _c(
                      "div",
                      { staticClass: "majorWarp" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "课程负责人说课视频：",
                              "label-width": "170px",
                            },
                          },
                          [
                            _c("div", { staticClass: "fj" }, [
                              _c("div", [
                                _vm._v(
                                  "提供15分钟说课视频一个，此项为必须提供。"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                说课视频含课程概述、教学设计思路、课程实施、后续建设措施等，视频中标注出镜人姓名、单位、课程负责人出镜时间不得少于3分钟。\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                技术要求：推荐分辨率1280*720，MP4格式,600M以内，图像清晰稳定，声音清楚，教师必须出境，视频使用的语言及字幕为国家通用语言及文字。\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("FileUpload", {
                              attrs: {
                                title: "授课视频上传",
                                accept: _vm.acceptVideo,
                              },
                              on: { successData: _vm.getUploadVideo },
                            }),
                            _vm._v(" "),
                            _vm.form6.lectureVideo.fileName
                              ? _c("div", { staticClass: "fjTit" }, [
                                  _vm._v(
                                    "\n              已上传：" +
                                      _vm._s(_vm.form6.lectureVideo.fileName)
                                  ),
                                  _c("span", { on: { click: _vm.open } }, [
                                    _vm._v("查看"),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "majorWarp" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "其他材料：",
                              "label-width": "170px",
                            },
                          },
                          [
                            _c("div", { staticClass: "fj" }, [
                              _vm._v("不超过2份，此项为选择性提供,格式：pdf。"),
                            ]),
                            _vm._v(" "),
                            _c("FileUpload", {
                              attrs: {
                                title: "附件材料上传",
                                accept: _vm.acceptPdf,
                              },
                              on: { successData: _vm.getUploadOtherFile },
                            }),
                            _vm._v(" "),
                            _vm.form6.otherFile1.fileName
                              ? _c("div", { staticClass: "fjTit" }, [
                                  _vm._v(
                                    "\n              已上传：" +
                                      _vm._s(_vm.form6.otherFile1.fileName)
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "delFile",
                                      on: { click: _vm.delFile1 },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form6.otherFile2.fileName
                              ? _c("div", { staticClass: "fjTit" }, [
                                  _vm._v(
                                    "\n              已上传：" +
                                      _vm._s(_vm.form6.otherFile2.fileName)
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "delFile",
                                      on: { click: _vm.delFile2 },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          以上材料均可能在网上公开，请严格审查，确保不违反有关法律及保密规定。\n        "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submitBtn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.submit6("form6")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: { title: "说课视频", visible: _vm.dialog },
          on: {
            "update:visible": function ($event) {
              _vm.dialog = $event
            },
            close: _vm.closeVideo,
          },
        },
        [
          _c(
            "video",
            {
              ref: "skVideo2",
              attrs: {
                src: _vm.form6.lectureVideo.ossOriUrl,
                controls: "controls",
              },
            },
            [
              _c("h2", [
                _vm._v("我们很抱歉，您的浏览器"),
                _c("strong", [_vm._v("不支持video标签")]),
              ]),
              _vm._v(" "),
              _c("a", { attrs: { href: "https://www.google.cn/chrome/" } }, [
                _vm._v("点击这里下载浏览器"),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }